
    <div class="flex flex-col bg-white  max-w-md w-full mx-auto shadow-md rounded-xl px-4" style="height: fit-content;">
          <div class="items-center  border-b-2  " style="border-color: #EEE;">
            <p class="texte-reviews my-5">{{ 'TRIP_REVIEWS.ARRIVED_MESSAGE' | translate }}</p>
          </div>
          <div class="flex flex-col items-center gap-3 self-stretch mt-5 ">
            <div class="text-question ">{{ 'TRIP_REVIEWS.MOOD_QUESTION' | translate }}</div>
            <div class="text-question-para">{{ 'TRIP_REVIEWS.ABOUT_TRIP' | translate }}</div>
          </div>
          <div class="grid grid-cols-3 gap-4 h-80 justify-center items-center p-4 max-w-md mx-auto">
          <div class="flex flex-col items-center" *ngFor="let emoji of emojis; let i = index">
            <div class="w-full h-full rounded-full cursor-pointer transition-all duration-200 hover:scale-110" 
                 [class.emoji-selected]="isEmojiSelected(emoji)"
                 (click)="selectEmoji(emoji)">
              <img [src]="emoji.assetPath" 
                   style="background: 50% / cover no-repeat; width: 80px; height: 80px;" 
                   [alt]="getEmojiAlt(emoji.name)"
                   class="rounded-full">
            </div>        
          </div>
        </div>
    <div class="flex justify-center my-4">
      <button class="submit-button" 
              [disabled]="!selectedEmoji || isSubmitting"
              [class.submit-button-disabled]="!selectedEmoji || isSubmitting"
              (click)="submitFeedback()">
        <span class="submit-text" *ngIf="!isSubmitting">{{ 'TRIP_REVIEWS.SUBMIT' | translate }}</span>
        <span class="submit-text" *ngIf="isSubmitting">{{ 'TRIP_REVIEWS.SUBMITTING' | translate }}</span>
      </button>
    </div>
    </div> 